import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';

export const LanguageToggle: React.FC = () => {
  const { uiLanguage, setUILanguage } = useTranslation();

  const toggleLanguage = () => {
    setUILanguage(uiLanguage === 'english' ? 'arabic' : 'english');
  };

  return (
    <button
      onClick={toggleLanguage}
      className="language-toggle"
      aria-label={`Switch to ${uiLanguage === 'english' ? 'Arabic' : 'English'}`}
      title={`Switch to ${uiLanguage === 'english' ? 'Arabic' : 'English'}`}
    >
      {uiLanguage === 'english' ? 'ع' : 'EN'}
    </button>
  );
};
